import { useEffect, useState } from "react";
import { type Theme, applyTheme, getStoredTheme } from "../lib/theme";

export function useTheme(): { theme: Theme; setTheme: (next: Theme) => void } {
  const [theme, setThemeState] = useState<Theme>(getStoredTheme);

  function setTheme(next: Theme) {
    applyTheme(next);
    setThemeState(next);
  }

  // When the choice is "system", track OS preference changes live.
  useEffect(() => {
    if (theme !== "system") return;
    const mq = window.matchMedia("(prefers-color-scheme: dark)");
    function onChange() {
      document.documentElement.classList.toggle("dark", mq.matches);
    }
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, [theme]);

  return { theme, setTheme };
}
